import React, {
  useState,
  useEffect,
  useContext,
} from "react";

import AgregarModeloDb from "../firebase/AgregarModeloDb";
import Alertas from "./Alertas";

import {
  auth,
  db,
} from "../firebase/firebaseConfig";

import { useNavigate } from "react-router-dom";

import { FaRegEdit } from "react-icons/fa";

import {
  getDocs,
  collection,
  where,
  query,
  limit,
} from "firebase/firestore";

import { UserContext } from "../context/UserContext";

import {
  Table,
  Segment,
  Input,
  Container,
  Header,
  Dropdown,
  Form,
  Button,
  Icon,
} from "semantic-ui-react";

import ExportarExcel from "../funciones/ExportarExcel";

const AgregarModelo = () => {
  const user = auth.currentUser;
  const { users } = useContext(UserContext);

  const navigate = useNavigate();

  // ==========================================================
  // ESTADOS
  // ==========================================================

  const [
    estadoAlerta,
    cambiarEstadoAlerta,
  ] = useState(false);

  const [
    alerta,
    cambiarAlerta,
  ] = useState({});

  const [
    modelo,
    setModelo,
  ] = useState("");

  const [
    leer,
    setLeer,
  ] = useState([]);

  const [
    marca,
    setMarca,
  ] = useState([]);

  const [
    mar,
    setMar,
  ] = useState("");

  const [
    buscador,
    setBuscador,
  ] = useState("");

  const [
    flag,
    setFlag,
  ] = useState(false);

  const [
    verificandoId,
    setVerificandoId,
  ] = useState(null);

  // ==========================================================
  // AGREGAR MODELO
  // ==========================================================

  const handleSubmit = async (e) => {
    e.preventDefault();

    cambiarEstadoAlerta(false);
    cambiarAlerta({});

    const modeloNormalizado =
      String(modelo || "")
        .toLocaleUpperCase()
        .trim();

    // ========================================================
    // VALIDAR MODELO
    // ========================================================

    if (!modeloNormalizado) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "No ha ingresado un Modelo.",
      });

      return;
    }

    // ========================================================
    // VALIDAR MARCA
    // ========================================================

    if (
      !mar ||
      mar === "Selecciona Opción:"
    ) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "No ha seleccionado una Marca.",
      });

      return;
    }

    // ========================================================
    // VALIDAR DUPLICADO
    //
    // Mantiene la lógica actual:
    // el nombre del modelo es único dentro de la empresa.
    // ========================================================

    const existe = leer.some(
      (item) =>
        String(
          item.modelo || ""
        )
          .toLocaleUpperCase()
          .trim() ===
        modeloNormalizado
    );

    if (existe) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "Ya existe este Modelo.",
      });

      return;
    }

    // ========================================================
    // GUARDAR
    // ========================================================

    try {
      const fechaActual =
        new Date();

      await AgregarModeloDb({
        modelo:
          modeloNormalizado,

        marca:
          mar,

        userAdd:
          user?.email || "",

        userMod:
          user?.email || "",

        fechaAdd:
          fechaActual,

        fechaMod:
          fechaActual,

        emp_id:
          users.emp_id,
      });

      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "exito",
        mensaje:
          "Modelo ingresado correctamente.",
      });

      setModelo("");
      setMar("");

      setFlag(
        (prev) => !prev
      );
    } catch (error) {
      console.error(
        "Error al agregar Modelo:",
        error
      );

      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "No fue posible ingresar el Modelo.",
      });
    }
  };

  // ==========================================================
  // OBTENER MARCAS
  // ==========================================================

  const getMarca = async () => {
    if (!users?.emp_id) {
      return;
    }

    try {
      const marcasRef =
        collection(
          db,
          "marcas"
        );

      const qMarcas =
        query(
          marcasRef,

          where(
            "emp_id",
            "==",
            users.emp_id
          )
        );

      const data =
        await getDocs(
          qMarcas
        );

      const marcas =
        data.docs
          .map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }))
          .sort((a, b) =>
            String(
              a.marca || ""
            ).localeCompare(
              String(
                b.marca || ""
              )
            )
          );

      setMarca(
        marcas
      );
    } catch (error) {
      console.error(
        "Error cargando Marcas:",
        error
      );

      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "No fue posible cargar las Marcas.",
      });
    }
  };

  // ==========================================================
  // OBTENER MODELOS
  // ==========================================================

  const getData = async () => {
    if (!users?.emp_id) {
      return;
    }

    try {
      const modelosRef =
        collection(
          db,
          "modelos"
        );

      const qModelos =
        query(
          modelosRef,

          where(
            "emp_id",
            "==",
            users.emp_id
          )
        );

      const data =
        await getDocs(
          qModelos
        );

      const modelos =
        data.docs
          .map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }))
          .sort((a, b) =>
            String(
              a.modelo || ""
            ).localeCompare(
              String(
                b.modelo || ""
              )
            )
          );

      setLeer(
        modelos
      );
    } catch (error) {
      console.error(
        "Error cargando Modelos:",
        error
      );

      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "No fue posible cargar los Modelos.",
      });
    }
  };

  // ==========================================================
  // VERIFICAR SI EL MODELO YA ESTÁ SIENDO UTILIZADO
  // ==========================================================

  const verificarModeloEnUso =
    async (nombreModelo) => {
      if (!users?.emp_id) {
        throw new Error(
          "No se encontró la empresa del usuario"
        );
      }

      const modeloNormalizado =
        String(
          nombreModelo || ""
        )
          .toLocaleUpperCase()
          .trim();

      if (!modeloNormalizado) {
        return false;
      }

      // ======================================================
      // 1. EQUIPOS
      // ======================================================

      const qEquipos =
        query(
          collection(
            db,
            "equipos"
          ),

          where(
            "emp_id",
            "==",
            users.emp_id
          ),

          where(
            "modelo",
            "==",
            modeloNormalizado
          ),

          limit(1)
        );

      const snapEquipos =
        await getDocs(
          qEquipos
        );

      if (!snapEquipos.empty) {
        return true;
      }

      // ======================================================
      // 2. INGRESOS SERVICIO TÉCNICO
      // ======================================================

      const qIngresos =
        query(
          collection(
            db,
            "ingresostcab"
          ),

          where(
            "emp_id",
            "==",
            users.emp_id
          ),

          where(
            "modelo",
            "==",
            modeloNormalizado
          ),

          limit(1)
        );

      const snapIngresos =
        await getDocs(
          qIngresos
        );

      if (!snapIngresos.empty) {
        return true;
      }

      return false;
    };

  // ==========================================================
  // EDITAR MODELO
  // ==========================================================

  const editarModelo =
    async (item) => {
      if (
        !item?.id ||
        !item?.modelo
      ) {
        return;
      }

      cambiarEstadoAlerta(false);
      cambiarAlerta({});

      setVerificandoId(
        item.id
      );

      try {
        const enUso =
          await verificarModeloEnUso(
            item.modelo
          );

        if (enUso) {
          cambiarEstadoAlerta(true);

          cambiarAlerta({
            tipo: "error",
            mensaje:
              "Este modelo ya está siendo utilizado en el sistema y no puede modificarse.",
          });

          return;
        }

        navigate(
          `/actualizamodelo/${item.id}`
        );
      } catch (error) {
        console.error(
          "Error verificando uso del Modelo:",
          error
        );

        cambiarEstadoAlerta(true);

        cambiarAlerta({
          tipo: "error",
          mensaje:
            "No fue posible verificar si el Modelo puede modificarse.",
        });
      } finally {
        setVerificandoId(
          null
        );
      }
    };

  // ==========================================================
  // FILTRO
  // ==========================================================

  const filtroModelo =
    leer.filter(
      (item) =>
        Object.keys(
          item
        ).some(
          (key) =>
            String(
              item[key] ?? ""
            )
              .toLowerCase()
              .includes(
                buscador.toLowerCase()
              )
        )
    );

  // ==========================================================
  // EXPORTAR EXCEL
  // ==========================================================

  const ExportarXls =
    () => {
      const columnsToShow =
        [
          "id",
          "modelo",
          "marca",
        ];

      const excelBlob =
        ExportarExcel(
          leer,
          columnsToShow
        );

      const excelURL =
        URL.createObjectURL(
          excelBlob
        );

      const downloadLink =
        document.createElement(
          "a"
        );

      downloadLink.href =
        excelURL;

      downloadLink.download =
        "modelo.xlsx";

      document.body.appendChild(
        downloadLink
      );

      downloadLink.click();

      document.body.removeChild(
        downloadLink
      );

      URL.revokeObjectURL(
        excelURL
      );
    };

  // ==========================================================
  // EFFECT
  // ==========================================================

  useEffect(() => {
    getData();
    getMarca();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    flag,
    users?.emp_id,
  ]);

  // ==========================================================
  // RENDER
  // ==========================================================

  return (
    <Container
      fluid
      style={{
        maxWidth: 1400,
        padding: "24px 28px",
        background: "#f8fafc",
        minHeight: "100vh",
      }}
    >
      {/* ==================================================== */}
      {/* ENCABEZADO */}
      {/* ==================================================== */}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 20,
          gap: 20,
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 14,
          }}
        >
          <div
            style={{
              width: 48,
              height: 48,
              minWidth: 48,
              borderRadius: 12,
              background: "#e5f7f7",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Icon
              name="tags"
              style={{
                margin: 0,
                color: "#0d9da5",
                fontSize: 21,
              }}
            />
          </div>

          <div>
            <Header
              as="h2"
              style={{
                margin: 0,
                color: "#172b4d",
                fontSize: 24,
                fontWeight: 700,
              }}
            >
              Modelos de Equipos
            </Header>

            <div
              style={{
                color: "#8793a5",
                fontSize: 13,
                marginTop: 4,
              }}
            >
              Administra los modelos de equipamiento médico y su marca asociada
            </div>
          </div>
        </div>

        <Button
          type="button"
          onClick={
            ExportarXls
          }
          style={{
            background: "#ffffff",
            color: "#526273",
            border:
              "1px solid #d7dee7",
            borderRadius: 6,
            boxShadow: "none",
          }}
        >
          <Icon
            name="file excel outline"
            style={{
              color: "#21ba45",
            }}
          />

          Exportar Excel
        </Button>
      </div>

      {/* ==================================================== */}
      {/* AGREGAR MODELO */}
      {/* ==================================================== */}

      <Segment
        style={{
          borderRadius: 8,
          border:
            "1px solid #e5e9ef",
          boxShadow:
            "0 2px 6px rgba(0,0,0,0.04)",
          padding: 0,
          background: "#ffffff",

          // IMPORTANTE:
          // permite desplegar correctamente el Dropdown de Marca.
          overflow: "visible",

          marginBottom: 14,
        }}
      >
        <div
          style={{
            padding:
              "14px 18px",
            borderBottom:
              "1px solid #edf0f4",
            display: "flex",
            alignItems: "center",
            gap: 9,
            fontWeight: 600,
            color: "#253858",
          }}
        >
          <Icon
            name="plus circle"
            style={{
              color: "#0d9da5",
            }}
          />

          Agregar nuevo modelo
        </div>

        <div
          style={{
            padding: 18,
          }}
        >
          <Form
            onSubmit={
              handleSubmit
            }
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  "minmax(260px, 1fr) minmax(300px, 1.5fr) auto",
                gap: 10,
                alignItems: "center",
              }}
            >
              {/* ============================================ */}
              {/* MARCA */}
              {/* ============================================ */}

              <Dropdown
                fluid
                search
                selection
                clearable
                placeholder="Selecciona Marca"
                value={
                  mar || ""
                }
                onChange={(
                  e,
                  { value }
                ) =>
                  setMar(
                    value || ""
                  )
                }
                options={
                  marca.map(
                    (item) => ({
                      key:
                        item.id ||
                        item.marca,
                      text:
                        item.marca,
                      value:
                        item.marca,
                    })
                  )
                }
                style={{
                  position:
                    "relative",
                  zIndex: 10,
                }}
              />

              {/* ============================================ */}
              {/* MODELO */}
              {/* ============================================ */}

              <Input
                fluid
                size="large"
                icon="tag"
                iconPosition="left"
                type="text"
                placeholder="Ingrese Modelo"
                name="modelo"
                value={
                  modelo
                }
                onChange={(
                  e
                ) =>
                  setModelo(
                    e.target.value
                  )
                }
              />

              {/* ============================================ */}
              {/* AGREGAR */}
              {/* ============================================ */}

              <Button
                type="submit"
                style={{
                  minWidth: 120,
                  height: 42,
                  background:
                    "#0d9da5",
                  color: "#ffffff",
                  borderRadius: 6,
                  boxShadow: "none",
                  margin: 0,
                }}
              >
                <Icon name="plus" />
                Agregar
              </Button>
            </div>
          </Form>
        </div>
      </Segment>

      {/* ==================================================== */}
      {/* LISTADO */}
      {/* ==================================================== */}

      <Segment
        style={{
          borderRadius: 8,
          border:
            "1px solid #e5e9ef",
          boxShadow:
            "0 2px 6px rgba(0,0,0,0.04)",
          padding: 0,
          background: "#ffffff",
          overflow: "hidden",
        }}
      >
        {/* CABECERA */}

        <div
          style={{
            padding:
              "14px 18px",
            borderBottom:
              "1px solid #edf0f4",
            display: "flex",
            justifyContent:
              "space-between",
            alignItems: "center",
            gap: 15,
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              fontWeight: 600,
              color: "#253858",
            }}
          >
            <Icon
              name="list"
              style={{
                color: "#0d9da5",
              }}
            />

            Modelos registrados

            <span
              style={{
                marginLeft: 8,
                fontSize: 11,
                color: "#98a1af",
                fontWeight: 400,
              }}
            >
              {filtroModelo.length} registros
            </span>
          </div>

          <div
            style={{
              width: 340,
              maxWidth: "100%",
            }}
          >
            <Input
              fluid
              icon="search"
              iconPosition="left"
              placeholder="Buscar Modelo"
              value={
                buscador
              }
              onChange={(e) =>
                setBuscador(
                  e.target.value
                )
              }
            />
          </div>
        </div>

        {/* ================================================== */}
        {/* TABLA */}
        {/* ================================================== */}

        <div
          style={{
            maxHeight: 520,
            overflowY: "auto",
            overflowX: "auto",
          }}
        >
          <Table
            celled
            compact
            selectable
            style={{
              margin: 0,
              border: 0,
              borderRadius: 0,
              fontSize: 12,
            }}
          >
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell
                  width={1}
                  textAlign="center"
                  style={
                    stickyTh
                  }
                >
                  N°
                </Table.HeaderCell>

                <Table.HeaderCell
                  style={
                    stickyTh
                  }
                >
                  Modelo
                </Table.HeaderCell>

                <Table.HeaderCell
                  style={
                    stickyTh
                  }
                >
                  Marca
                </Table.HeaderCell>

                <Table.HeaderCell
                  style={
                    stickyTh
                  }
                >
                  Agregado por
                </Table.HeaderCell>

                <Table.HeaderCell
                  style={
                    stickyTh
                  }
                >
                  Modificado por
                </Table.HeaderCell>

                <Table.HeaderCell
                  width={2}
                  textAlign="center"
                  style={
                    stickyTh
                  }
                >
                  Acción
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {filtroModelo.map(
                (
                  item,
                  index
                ) => (
                  <Table.Row
                    key={
                      item.id ||
                      index
                    }
                  >
                    <Table.Cell
                      textAlign="center"
                    >
                      {index + 1}
                    </Table.Cell>

                    <Table.Cell
                      style={{
                        fontWeight: 500,
                        color: "#344563",
                        maxWidth: 300,
                        whiteSpace:
                          "nowrap",
                        overflow: "hidden",
                        textOverflow:
                          "ellipsis",
                      }}
                      title={
                        item.modelo
                      }
                    >
                      {item.modelo}
                    </Table.Cell>

                    <Table.Cell
                      style={{
                        color: "#526273",
                        maxWidth: 260,
                        whiteSpace:
                          "nowrap",
                        overflow: "hidden",
                        textOverflow:
                          "ellipsis",
                      }}
                      title={
                        item.marca
                      }
                    >
                      {item.marca ||
                        "-"}
                    </Table.Cell>

                    <Table.Cell>
                      {item.useradd ||
                        item.userAdd ||
                        "-"}
                    </Table.Cell>

                    <Table.Cell>
                      {item.usermod ||
                        item.userMod ||
                        "-"}
                    </Table.Cell>

                    <Table.Cell
                      textAlign="center"
                    >
                      <Button
                        icon
                        size="mini"
                        type="button"
                        title="Editar Modelo"
                        loading={
                          verificandoId ===
                          item.id
                        }
                        disabled={
                          verificandoId !==
                            null &&
                          verificandoId !==
                            item.id
                        }
                        onClick={() =>
                          editarModelo(
                            item
                          )
                        }
                        style={{
                          width: 34,
                          height: 30,
                          padding: 0,
                          margin: 0,
                          borderRadius: 5,
                          border:
                            "1px solid #168bc1",
                          background:
                            "#f4fbfe",
                          boxShadow:
                            "none",
                        }}
                      >
                        {verificandoId !==
                          item.id && (
                          <FaRegEdit
                            style={{
                              fontSize: 15,
                              color:
                                "#168bc1",
                            }}
                          />
                        )}
                      </Button>
                    </Table.Cell>
                  </Table.Row>
                )
              )}

              {filtroModelo.length ===
                0 && (
                <Table.Row>
                  <Table.Cell
                    colSpan={6}
                    textAlign="center"
                    style={{
                      padding: 28,
                      color:
                        "#8995a3",
                    }}
                  >
                    <Icon
                      name="search"
                      style={{
                        marginRight: 6,
                      }}
                    />

                    No se encontraron Modelos
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
        </div>

        {/* FOOTER */}

        {filtroModelo.length >
          0 && (
          <div
            style={{
              padding:
                "12px 18px",
              borderTop:
                "1px solid #edf0f4",
              color: "#697586",
              fontSize: 12,
            }}
          >
            Mostrando{" "}
            <strong>
              {filtroModelo.length}
            </strong>{" "}
            modelos
          </div>
        )}
      </Segment>

      <Alertas
        tipo={
          alerta.tipo
        }
        mensaje={
          alerta.mensaje
        }
        estadoAlerta={
          estadoAlerta
        }
        cambiarEstadoAlerta={
          cambiarEstadoAlerta
        }
      />
    </Container>
  );
};

// ============================================================
// HEADER STICKY
// ============================================================

const stickyTh = {
  position: "sticky",
  top: 0,
  zIndex: 2,
  background: "#f8fafc",
  color: "#344563",
  fontWeight: 600,
};

export default AgregarModelo;